import Dropdown from "components/blocks/Dropdown";
import LoadingOverlay from "components/blocks/LoadingOverlay";
import useMutation from "hooks/useMutation";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { ExaminersService } from "services/examinersService";
import {
  ExaminerListResult,
  UpdateExaminerAccreditationTypeRequest,
  AccreditationTypes,
} from "services/examinersService/Model/ExaminerTypes";

const AcceptRejectExaminerEvaluationDDL = ({
  row,
  setTriggerTableUpdate,
}: {
  row: ExaminerListResult;
  setTriggerTableUpdate: Dispatch<SetStateAction<boolean>>;
}) => {
  const { t } = useTranslation(["Orders"]);

  const { mutateAsync, loading } = useMutation({
    queryFn: async ({
      courseOrderExaminerId,
      request,
    }: {
      courseOrderExaminerId: number;
      request: UpdateExaminerAccreditationTypeRequest;
    }) => {
      return await ExaminersService.updateExaminerAccreditationType(courseOrderExaminerId, request);
    },
  });

  const onApproveRejectExaminer = async (accreditationType: string) => {
    const parsedType = parseInt(accreditationType);
    await mutateAsync({
      courseOrderExaminerId: row.id,
      request: {
        type: parsedType,
      },
    });

    setTriggerTableUpdate((prev) => !prev);
  };

  return (
    <div className="position-relative">
      <LoadingOverlay visible={loading} />
      <Dropdown
        data={[
          { id: `${AccreditationTypes.Accreditation.value}`, value: t("approveExaminerResult") },
          { id: `${AccreditationTypes.Reject.value}`, value: t("rejectExaminerResult") },
        ]}
        disabled={loading}
        value={
          !row.accreditationType
            ? ""
            : row.accreditationType === AccreditationTypes.Accreditation.label
            ? `${AccreditationTypes.Accreditation.value}`
            : `${AccreditationTypes.Reject.value}`
        }
        noSelectionPlaceholder={t("selectExaminerEvaluationResult")}
        onChange={onApproveRejectExaminer}
      />
    </div>
  );
};

export default AcceptRejectExaminerEvaluationDDL;
